import { render, staticRenderFns } from "./HomeLikeRoute.vue?vue&type=template&id=0baf65bc&scoped=true"
import script from "./HomeLikeRoute.vue?vue&type=script&lang=js"
export * from "./HomeLikeRoute.vue?vue&type=script&lang=js"
import style0 from "./HomeLikeRoute.vue?vue&type=style&index=0&id=0baf65bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf65bc",
  null
  
)

export default component.exports